/**
 * 首页"礼包天天领"模块逻辑
 */
import recommend from '@/api/wechatQuery'

/**
 * 对yewu1 yewu2...进行排序
 */
function sortNumber(a: string, b: string) {
  return Number(a.slice(4)) - Number(b.slice(4))
}

/**
 * 获取推荐数据
 */
export async function getRecommend() {
  let model
  try {
    model = await recommend({ model: 'welfare_index_gift_recomm_android' })
  } catch {
    return []
  }

  if (model && model.ret === 0 && model.recomm_info) {
    // 需要按key的顺序进行排序
    return Object.keys(model.recomm_info)
      .sort(sortNumber)
      .map(key => model.recomm_info[key])
  }
  return []
}

/**
 * 处理礼包天天领模块数据，通过推荐的顺序排序，若推荐的为空，则默认兜底顺序：  王者首位，其他任意顺序平铺
 *
 * recommendList 请求推荐接口返回的groupId_busId组成的数组
 * configList 配置的业务列表
 */
export function handlerGiftList({ recommendList, configList }: { recommendList: any[]; configList: any[] }) {
  if (!configList || configList.length === 0) {
    return []
  }
  const configMap = {}
  const list = []
  configList.forEach(item => {
    if (item && item.groupId_busId) {
      configMap[item.groupId_busId] = item
    }
  })
  recommendList.forEach(item => {
    configMap[item] && list.push(configMap[item])
  })
  if (list.length > 0) {
    return list
  }
  let item
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < configList.length; i++) {
    if (configList[i].groupId_busId === '2_2') {
      item = configList[i]
      configList.splice(i, 1)
      break
    }
  }
  if (item) {
    configList.unshift(item)
  }
  return configList
}
